import Api from '@/api'
import * as Sentry from '@sentry/browser'

import ENUM from '@/assets/ENUM'

import Storage from '@/helpers/storage'

import Auth from '@/modules/auth'
import Loop from '@/modules/loop'
import Firebase from '@/modules/firebase'

import {configuration} from '../../../configuration'

const User = {
    
    refreshSubscriptions(asyncFetchMeantime) {
    
        return Loop.start(Api.newsletters.get, asyncFetchMeantime)
            .then(async data => {
                data.subscriptions = await sortSubscriptions(data.subscriptions, data.extras)
                return data
            })
            .catch(() => {
                Sentry.captureException(new Error('Error during partial Loop.start'))
            })
    },
    
    
    waitUnfinishedMailboxes() {
        return callSubscriptionsApiRecursively()
            .then(async data => {
                data.subscriptions = await sortSubscriptions(data.subscriptions, data.extras)
                return data
            })
            .catch(() => {
                Sentry.captureException(new Error('Error during partial callSubscriptionsApiRecursively'))
            })
    },
    
    getUserAsync() {

        return Api.user.getUser()
            .catch(() => {
                Auth.disconnect()
            })
    },

    async getUserSync() {
        return await Api.user.getUser()
    },

    mergeMailboxes(newArray, oldArray) {
        return newArray.map(newMailbox => ({...oldArray.find(oldMailbox => oldMailbox.email === newMailbox.email), ...newMailbox}))
    }
}


export default User

async function sortSubscriptions(subscriptions = [], extras) {
    const sortArray = [
        ...subscriptions.filter(item => !item.invalidGrant),
        ...subscriptions.filter(item => item.invalidGrant)
    ]
    const arrayWithAdds = await subscriptionsAdds(sortArray, extras)
    
    return arrayWithAdds
}

async function subscriptionsAdds(array, extras) {
    
    if (!Storage.getItem('usedSharingCard')) {
        const sharingCard = {type: ENUM.NEWSLETTERS.CARDS.SHARING}
        await Firebase.getValue('sharing_cards_positions', 'Object')
            .then(firebaseData => {
                return firebaseData && firebaseData.positions
                    ? addCardWithPosition(array, firebaseData.positions, sharingCard)
                    : addCardWithPosition(array, configuration.sharingCardsPositionDefault, sharingCard)
            })
            .catch(() => {
                return addCardWithPosition(array, configuration.sharingCardsPositionDefault, sharingCard)
            })
        
    }
    
    for (const specialCard of extras) {
        addCardWithPosition(array, [specialCard.position], {...specialCard, type: ENUM.NEWSLETTERS.CARDS.MARKET})
    }
    
    //todo: greenfox card
    // if (I18n.get(this) === 'fr' && this.newsletters.length > 10) {
    //     this.newsletters.splice(9, 0, {
    //         type: 'greenfox',
    //         tag: 'greenfox_card',
    //         cta: 'https://app.adjust.com/ls6zp1s'
    //     })
    // }
    
    array.forEach(item => item.type = item.type || ENUM.NEWSLETTERS.CARDS.SUBSCRIPTIONS)
    
    return array
    
}

function addCardWithPosition(array, positions, card) {
    positions.forEach(position => {
        if (array.length > position) {
            array.splice(position, 0, card)
        }
    })
    return array
}

function callSubscriptionsApiRecursively() {
    return new Promise((resolve, reject) => {
        Api.newsletters.get()
            .then(response => {
                const isMailboxeProcessing = response.mailboxes.filter(mailbox => !mailbox.done).length > 0
                const retry = response.retry && response.retry >= 1000 ? response.retry : 1000
                if (isMailboxeProcessing) {
                    setTimeout(() => {
                        callSubscriptionsApiRecursively()
                            .then(resolve)
                            .catch(reject)
                    }, retry)
                } else {
                    resolve(response)
                }
            })
            .catch(err => reject(err))
    })
}